import type {
  InboxMessageStatus,
  RecipientModelRead,
  SmsSettingsModel,
  SmsStatusModel,
} from 'api/inbox2'
import { IEmailAttachment } from 'Modules/Communication/Email/shared/models/Email'
import { RecipientTypeEnum } from 'Modules/Communication/shared/models/Inbox'

export interface IEmailMessage {
  contentHtml: string
  title: string
  attachments?: IEmailAttachment[]
}

export interface ISmsMessage {
  content: string
}

export interface SendMessagePatchBody {
  op: 'replace'
  path: string
  value: string
}

export type IMessageReciept = {
  recipients?: IMessageRecieptRecipient[] | null
  sendingStatus?: InboxMessageStatus | SendMessageStatusEnum
}

export type IMessageRecieptRecipient = RecipientModelRead & {
  isAdded?: boolean
}

export type SmsSettings = SmsSettingsModel & SmsStatusModel

export interface ILoadingMessageRecipient {
  type: 'remove' | 'add'
  recipientType: RecipientTypeEnum
  id: string
}

export type SendEmailFieldName = 'title' | 'contentHtml'

export enum SendMessageStateEnum {
  send = 'send',
  reciept = 'reciept',
}

export enum SendMessageStatusEnum {
  Sent = 'Sent',
  Sending = 'Sending',
  Error = 'Error',
}
